<app-page-header
  title="RSS Validator"
  [breadcrumbs]="breadcrumb"
></app-page-header>

<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">
      <app-rss-validator-form></app-rss-validator-form>
    </div>
  </div>
</section>
